import React from 'react';
import classes from './FilterTabs.module.pcss';
import DataValidator from 'js/components/Common/DataValidator/DataValidator';
import LearningPathStore from 'js/store/LearningPathStore';
import {observer} from 'mobx-react';

const FilterTabs = () => {
    const data = LearningPathStore.activeTabData;
    const tabs = data?.filterTabs;
    return (
        <DataValidator data={tabs?.length > 0}>
            <ul className={classes.FilterTabs}>
                {tabs?.map((tab, index) => {
                        if (!tab?.faq?.length) {
                            return '';
                        }
                        return (
                            <li onClick={() => {
                                LearningPathStore.lastClickedElement = '';
                                LearningPathStore.setActiveFilterTab(tab?.ufid);
                                LearningPathStore.setActiveFAQContent();
                            }}
                                className={LearningPathStore.activeFilterTab === tab?.ufid ? classes.Active : ''}
                                key={index}>
                                <span>{tab?.tabTitle}</span>
                                <span>{tab?.tabTitle}</span>
                            </li>
                        );
                    }
                )}
            </ul>
        </DataValidator>
    );
};

export default observer(FilterTabs);
